import { PRIMARY_BLUE, SECONDARY_GREY } from "src/constants/colors";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

export const LeftDrawerContainer = styled.div<{ isCollapsed: boolean }>`
  overflow: hidden;
  transition: width 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  width: ${({ isCollapsed }) => (isCollapsed ? "64px" : "100%")};
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const CollapseDivider = styled.div`
  border-bottom: 1px solid ${SECONDARY_GREY};
  margin: 8px 16px 16px;
`;

export const PorchPassLogo = styled.div<{ isCollapsed: boolean }>`
  position: relative;
  height: 32px;
  margin: ${({ isCollapsed }) => (isCollapsed ? "24px 12px" : "24px 20px")};
  width: ${({ isCollapsed }) => (isCollapsed ? "40px" : "242px")};
  display: flex;
  align-items: center;
  justify-content: ${({ isCollapsed }) =>
    isCollapsed ? "center" : "space-between"};
  transition: width 0.3s ease-in-out;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 34px;
  align-items: center;
  margin: 0 0 0 16px;
  text-decoration: none;
`;

export const CollapseButton = styled.button<{ isCollapsed: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 32px;
  transition: all 0.3s ease-in-out;
  transform: ${({ isCollapsed }) =>
    isCollapsed ? "rotate(180deg)" : "rotate(0deg)"};

  &:hover {
    background-color: rgba(235, 238, 243, 1);
  }

  svg {
    width: 18px;
    height: 18px;
    color: rgba(74, 84, 102, 1);
  }
`;

export const LogoLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== "isCollapsed",
})<{ isCollapsed?: boolean }>`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    max-height: 32px;
    max-width: 130px;
    transition: all 0.3s ease-in-out;
  }
`;

export const Container = styled(Link)`
  display: flex;
  flex-direction: row;
  height: 34px;
  align-items: center;
  text-decoration: none;
`;

export const IndicatorNub = styled.div<{ isCurrent: boolean }>`
  visibility: ${(props) => (props.isCurrent ? "visible" : "hidden")};
  background: linear-gradient(
    180deg,
    rgba(64, 117, 255, 1) 0%,
    rgba(60, 113, 251, 1) 100%
  );
  border: 1px solid rgba(0, 92, 214, 0.01);
  box-shadow: inset -2px 0px 0px -1.1px rgba(255, 255, 255, 0.2);
  border-radius: 120px;
  height: 8px;
  margin-left: -9px;
  width: 11px;
`;

export const Content = styled.div<{ isCurrent: boolean; isCollapsed: boolean }>`
  background-color: ${(props) =>
    props.isCurrent ? BLUE_LIGHT : "transparent"};
  box-sizing: border-box;
  color: ${(props) => (props.isCurrent ? OLD_BLUE : "rgba(74, 84, 102, 1)")};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  height: 30px;
  margin: 0px 30px;
  padding: 8px 0px;
  position: relative;
  transition: background-color 0.25s ease;
  width: calc(100% - 60px);
  z-index: 1;

  /* Hide content when collapsed except for icon */
  ${({ isCollapsed }) =>
    isCollapsed &&
    `
    margin: 0px 8px;
    width: 48px;
    justify-content: center;
    gap: 0;
    border-radius: 8px;
  `}

  &:hover {
    background-color: ${(props) =>
      props.isCurrent ? BLUE_LIGHT : "rgba(235, 238, 243, 1)"};
    &::before,
    &::after {
      background-color: ${(props) =>
        props.isCurrent ? BLUE_LIGHT : "rgba(235, 238, 243, 1)"};
    }
  }

  &::before,
  &::after {
    background-color: ${(props) =>
      props.isCurrent ? BLUE_LIGHT : "transparent"};
    content: "";
    display: block;
    height: 30px;
    position: absolute;
    top: 0px;
    transition: background-color 0.25s ease;
    width: 30px;
    z-index: -1;

    /* Hide pill edges when collapsed */
    ${({ isCollapsed }) => isCollapsed && `display: none;`}
  }

  &::before {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    left: -30px;
    margin-left: 15px;
  }

  &::after {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    right: -30px;
    margin-right: 15px;
  }
`;

export const IconWrapper = styled.div`
  height: 18px;
  width: 18px;
`;

export const Title = styled.div<{ isCollapsed: boolean }>`
  font-size: 14px;
  display: ${({ isCollapsed }) => (isCollapsed ? "none" : "block")};
`;

export const AdminLabel = styled.div<{ isCollapsed: boolean }>`
  position: absolute;
  top: -6px;
  left: 35px;
  font-size: 12px;
  font-style: italic;
  color: ${PRIMARY_BLUE};
  display: ${({ isCollapsed }) => (isCollapsed ? "none" : "block")};
  font-weight: bold;
`;
